module.exports = __webpack_public_path__ + "portal/static/img/tnc.9640d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/tnc.png
// module id = T6wi
// module chunks = 67